export default __webpack_public_path__ + "static/media/1128040325513326.65cf2528.jpg";